import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Tree.module.scss';

import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import FlexRow from 'Flow2/components/UI/Container/FlexRow'
import FlexCol from 'Flow2/components/UI/Container/FlexColumn'

import { injectIntl } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare, faMinusSquare, faFolderOpen, faFolder, faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';

const hasChilds = (data, selector) => {
    return data[selector] && data[selector].length;
}

const getChilds = (data, selector) => {
    return hasChilds(data, selector) ? data[selector] : [];
}

const Child = (props) => {
    let childArray = getChilds(props.data, 'children');
	
    let childs = childArray.map((data) => {
        return (
            <Child
                key={data.id}
                registerCollapsed={props.registerCollapsed}
                toggleCollapsed={props.toggleCollapsed}
                collapsed={props.collapsed}
                onAdd={props.onAdd}
                onRemove={props.onRemove}
				onClick={props.onClick}
                isSelected={props.isSelected}
                controls={props.controls}
                data={data} />
        );
    });
    
    if(childs.length && props.collapsed[props.data.id] === undefined) {
        //props.registerCollapsed(props.data.id);
    }
    
    let cls = classes;
    
    let selected = "";
    if(props.isSelected) {
        selected = props.isSelected(props.data);
    }
    
    let add = "";
    if(props.controls && props.onAdd) {
        add = (
            <div className={[cls.Control, cls.Add, selected].join(' ')} onClick={() => props.onAdd(props.data)}>
                <FontAwesomeIcon icon={faPlusSquare} />
            </div>
        );
    }
    
    let remove = "";
    if(props.controls && props.onRemove) {
        remove = (
            <div className={[cls.Control, cls.Remove, selected].join(' ')} onClick={() => props.onRemove(props.data)}>
                <FontAwesomeIcon icon={faMinusSquare} />
            </div>
        );
    }
    
    return (
        <FlexCol className={cls.ChildContainer}>
                <FlexRow className={[cls.ChildHeader, selected].join(' ')} >
                    <Collapse
                        data={props.data}
                        childs={childs}
                        toggleCollapsed={props.toggleCollapsed}
                        collapsed={props.collapsed}
                        cls={cls}/>
                    <div className={[cls.Click, "flexGrow", "pointer"].join(' ')} onClick={() => props.onClick(props.data)}>{ props.data.name }</div>
                    { add }
                    { remove }
                </FlexRow>
                
                <FlexCol className={[cls.Childs, childs.length ? cls.hasChilds : cls.noChilds].join(' ')}>
                    { !props.collapsed[props.data.id] ? childs : "" }
                </FlexCol>
            </FlexCol>
    );
}

class Tree extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            open: true,
            collapsed: {},
            collapsedAll: true,
			filter: null,
			tree: []
        }
    }
    
    toggle = () => {
        this.setState({
            open: !this.state.open
        });
    }
    
    registerCollapsed = (id) => {
        let collapsed = { ...this.state.collapsed };
        collapsed[id] = true;
        this.setState({
            collapsed: collapsed
        });
    }
    
    toggleCollapsed = (id) => {
        let collapsed = { ...this.state.collapsed };
        collapsed[id] = !collapsed[id];
        this.setState({
            collapsed: collapsed
        });
    }

    toggleCollapseAll = (collapse) => {
        let collapsed = { ...this.state.collapsed };
        for(let key in collapsed) {
            collapsed[key] = collapse;
        }
        this.setState({
            collapsed: collapsed
        });
    }
	
	onClick = (data) => {
		
	}
    
    onAdd = (data) => {
        
    }
    
    onRemove = (data) => {
        
    }
	
	isSelected = (data) => {
        
    }
	
	filterTree = (data, filter) => {
		if(filter && filter.search && filter.field) {
			return this.walkThrough(data, filter);
		}
		return [ ...data ] || [];
	}
	
	walkThrough = (data, filter) => {
		let tree = []
		for(let i = 0; i < data.length; i++) {
			let elm = { ...data[i] };
			let childs = this.walkThrough(getChilds(elm, 'children'), filter);
			elm['children'] = childs;
			
			if(childs.length) {
				tree.push(elm);
			} else if(elm[filter.field] && elm[filter.field].toLowerCase().indexOf(filter.search.toLowerCase()) !== -1) {
				tree.push(elm);
			}
		}
		
		return tree;
	}
   
    render() {
        let tree = this.filterTree(this.props.data, this.props.filter).map((data) => {
            return (
                <Child
                    key={data.id}
                    registerCollapsed={this.registerCollapsed}
                    toggleCollapsed={this.toggleCollapsed}
                    collapsed={this.state.collapsed}
                    onAdd={this.props.onAdd || this.onAdd}
                    onRemove={this.props.onRemove || this.onRemove}
					onClick={this.props.onClick || this.onClick}
                    isSelected={this.props.isSelected || this.isSelected}
                    controls={this.props.controls || false}
                    data={data} />
            );
        });

        let cls = classes;

        return (
            <FlexCol className={[cls.TreeContainer].join(' ')}>
                <FlexRow className={[cls.TreeHeader].join(' ')}>
                    <div className={["flexGrow"].join(' ')}>{this.props.title}</div>
						{this.props.controls}
                    <div className={[cls.Control].join(' ')} onClick={() => this.toggleCollapseAll(true)}>
                        <FontAwesomeIcon icon={faFolder} />
                    </div>
                    <div className={[cls.Control].join(' ')} onClick={() => this.toggleCollapseAll(false)}>
                        <FontAwesomeIcon icon={faFolderOpen} />
                    </div>
                    <div className={[cls.Control].join(' ')} onClick={this.toggle}>
                        <FontAwesomeIcon icon={this.state.open ? "chevron-up" : "chevron-down"} />
                    </div>
                </FlexRow>
                {this.props.extraContent}
					<TreeContent
                    tree={tree}
                    open={this.state.open}
                    loading={this.props.loading}
                    cls={cls} />
            </FlexCol>
        );
        
    }
};

const TreeContent = (props) => {
    if(!props.open) return "";
    if(props.loading) return (<Spinner />);
    
    return (
        <FlexCol className={props.cls.TreeContent}>
            { props.tree }
        </FlexCol>
    );
}

const Collapse = (props) => {
    if(!props.childs.length) {
        return <><div className={[props.cls.Collapse].join(' ')} /></>
    }
    
    let icon = props.collapsed[props.data.id] ? faCaretRight : faCaretDown;
    
    return (
        <div className={[props.cls.Control, props.cls.Collapse].join(' ')} onClick={() =>  props.toggleCollapsed(props.data.id)}>
            <FontAwesomeIcon icon={icon} />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {

    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Tree));
